import { read, utils } from 'xlsx';

export type XlsxRowResult = { line: number; status: 1 | 0; msg: string; score?: number };

export function getCell(
    row: unknown[],
    cols: Record<string, number> | undefined,
    key: string,
): string {
    if (!cols || cols[key] == null) return '';
    const raw = row[cols[key] as number];
    if (raw === undefined || raw === null) return '';
    return String(raw).replace(/\u0000/g, '').replace(/['"]/g, '').trim();
}

export function toInt(s: string): number | undefined {
    if (s === '') return undefined;
    const n = parseInt(s, 10);
    return Number.isNaN(n) ? undefined : n;
}

export function toFloat(s: string): number | undefined {
    if (s === '') return undefined;
    const t = s.replace(/,/g, '.');
    const n = parseFloat(t);
    return Number.isNaN(n) ? undefined : n;
}

export function toBool(s: string): boolean | undefined {
    if (s === '') return undefined;
    const u = s.toLowerCase();
    if (u === '1' || u === 'true' || u === 'כן' || u === 'yes') return true;
    if (u === '0' || u === 'false' || u === 'לא' || u === 'no') return false;
    const n = parseInt(s, 10);
    if (!Number.isNaN(n)) return n !== 0;
    return undefined;
}

/**
 * After sheet_to_json: row 0 or 0+1 = headers; data never includes header row.
 * Must match uploadFileDialog checkValidExcel: headers = skip ? rows[1] : rows[0].
 */
export function getDataRowsAndMeta(
    rows: unknown[][],
    skipFirstLine: boolean,
): { dataRows: unknown[][]; firstDataSheetLine1Based: number } {
    const dataRows = skipFirstLine ? rows.slice(2) : rows.slice(1);
    const firstDataSheetLine1Based = skipFirstLine ? 3 : 2;
    return { dataRows, firstDataSheetLine1Based };
}

export async function readAsXlsxRows(file: File): Promise<unknown[][]> {
    const readTextWithEncoding = (f: File, encoding = 'windows-1255'): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsText(f, encoding);
        });

    const text = await readTextWithEncoding(file, 'windows-1255');
    let wb: ReturnType<typeof read>;
    if (text.startsWith('<HTML>') || text.includes('<TABLE')) {
        wb = read(text, { type: 'string' });
    } else {
        const buffer = await file.arrayBuffer();
        wb = read(buffer, { type: 'array' });
    }
    const ws = wb.Sheets[wb.SheetNames[0]];
    const rows = utils.sheet_to_json(ws, { header: 1, raw: false }) as unknown[][];
    return rows || [];
}
